// these properties will be available from anywhere via this.property
export const constants = {
  isTouch: function () {
    let isTouch = "ontouchstart" in window;

    document.body.classList.add((isTouch ? '' : 'no-') + "touch");
    return isTouch;
  }()
};


export function navFunction() {
  let openMenuClassName = 'open-menu';
  let openMenuSelector = '.' + openMenuClassName;
  let languageLinkSelector = '.weglot-parent-menu-item > a';
  let body = $('body');

  body.on('click', openMenuSelector + ', ' + languageLinkSelector, function (e) {
    e.preventDefault();

    let link = $(this);
    let isOpenMenuLinkType = link.hasClass(openMenuClassName);

    if (isOpenMenuLinkType) {
      body.toggleClass('show-menu');
    } else {
      link.closest('li').toggleClass('open');
    }
  });
}

export function alertBar() {
  $('body').on('click', '.close-alert', function (e) {
    e.preventDefault();

    $(this).closest('.alert-bar').slideUp(400, function () {
      let api = window.api;

      $(this).remove();

      if (api !== undefined && (api.updateHero !== undefined)) {
        requestAnimationFrame(api.updateHero);
      }
    });
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/module.js